import { Injectable } from '@angular/core';
import { IMapper } from '@core/base/mapper.interface';
import { IProfileUpdateRequestDto } from '@core/interfaces/api/profile/profile-dto.interface';
import { IProfileForm } from '../interfaces/profile-form.interface';

@Injectable()
export class ProfileFormToApiMapperService
  implements IMapper<IProfileForm, IProfileUpdateRequestDto>
{
  mapTo(formData: IProfileForm): IProfileUpdateRequestDto {
    return {
      name: formData.name,
    };
  }
}
